import { createContext, ReactNode, useContext } from 'react';

const BackboneContext = createContext<object | null>(null);

export const BackboneProvider = <T extends object>({ bridge, children }: { bridge: T; children: ReactNode }) => {
    return <BackboneContext.Provider value={bridge}>{children}</BackboneContext.Provider>;
};

export const useBackbone = <T extends object>() => {
    const context = useContext(BackboneContext);

    if (!context) throw new Error('useBackbone must be used within a BackboneProvider');

    return context as T;
};
